"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DadosSkuAlterado = void 0;
var DadosSkuAlterado = /** @class */ (function () {
    function DadosSkuAlterado(_a) {
        var _b = _a._id, _id = _b === void 0 ? { m: '', d: '', e: '', c: '', g: '' } : _b, _c = _a.qtdNecAntecipada, qtdNecAntecipada = _c === void 0 ? 0 : _c;
        this._id = { m: '', d: '', e: '', c: '', g: '' };
        this._id = _id;
        this.qtdNecAntecipada = qtdNecAntecipada;
    }
    return DadosSkuAlterado;
}());
exports.DadosSkuAlterado = DadosSkuAlterado;
//# sourceMappingURL=DadosSkuAlterado.js.map